import React, { useState, useEffect, useMemo } from "react";
import { exportToExcel } from "react-json-to-excel";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  Radio,
  Paper,
  Tooltip,
  Button,
  InputLabel,
  ListItem,
  Typography,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import DoBarChart from "../DoBarChart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import ReasonCodeChart from "./ReasonCodeChart";
import { active } from "d3";
import SingleBarChartForRDD from "./SingleBarChartForRDD";
import ExpetedTimeChart from "./ExpetedTimeChart";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 5px",
    },
    padding: "0px 16px !important",
  },
  selectList: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "75px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 5px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginLeft: "1vw",
  },
}));

const GraphViewIOFPB = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Customers,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
  CL6,
  setIOFPBRadioButton,
  dateType,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  // const [yAxisTitle, setYAxisTitle] = useState('');
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [countValue, setCountValue] = useState("5");
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const [graphData, setGraphData] = useState([]);
  // const [graphDate, setGraphDate] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue
  )[0].name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const countListReasonCode = [1, 5, 10, 25, 50, 100];
  // const storeData = useSelector((state) => state);
  const [reasonCode, setReasonCode] = useState("2S");
  const radioButtonSelected = useSelector(
    (state) => state?.filter?.radioButtonIOFPB
  );
  const incoterm = useSelector((state) => state?.filter?.incoTerm);

  const radioOptions = () => {
    if (activeTab === "Reason Codes") {
      return ["Customer Group", "CSM", "CSA"];
    }
    if (activeTab === "Revision Before RDD") {
      return ["Customer Group", "Reason Codes", "CSM", "CSA"];
    }
    if (activeTab === "Days Order Change") {
      return ["Customer Group", "Reason Codes", "CSM", "CSA"];
    }
    if (activeTab === "Expected On-time") {
      return ["Customer Group", "CSM", "CSA"];
    }
    return [];
  };
  // const [selectedRadioValue, setSelectedRadioValue] = useState(radioButtonSelected);

  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data?.data ? data?.data?.data : data?.data);
          // setGraphDate(data?.data)
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };

  const getValueToPass = () => {
    if (radioButtonSelected === "Customer Group") {
      return "Customer";
    } else if (radioButtonSelected === "Reason Codes") {
      return "ReasonCode";
    } else {
      return radioButtonSelected;
    }
  };

  const memoizedParams = useMemo(() => {
    const params = {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: getValueToPass(),
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis: getValueToPass(),
      Level: role,
      incoTerm: incoterm,
      dateType: dateType,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        PL3: PL3,
        Division: Division,
        CL6,
        Products: Products,
        SoldToName: Customers,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    };
    if (activeTab === "Reason Codes") {
      params.ReasonCode = [reasonCode];
    }
    return params;
  }, [
    Module,
    tabValue,
    radioButtonSelected,
    topOrBottomValue,
    countValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    CL6,
    Customers,
    date,
    reasonCode,
    incoterm,
    dateType,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const getTooltipTitle = (item) => {
    switch (item) {
      case "Reason Codes":
        return "# and % share of orders with the selected reason code where original RDD lies in the selected time period vs the benchmark";
      case "Revision Before RDD":
        return "Avg # of days before the Original RDD that the RDD revision was made for orders with original RDD in the selected date range";
      case "Days Order Change":
        return "Avg # of days of RDD delay from the Original RDD for orders with original RDD in the selected date range";
      case "Expected On-time":
        return "% of orders without RDD delays attributed to Nestle reason codes out of all orders with Original RDD in the selected date range";

      default:
        return "This is additional information about the Chart";
    }
  };

  const getDataForExport = () => {
    const params = {
      module: Module,
      X_Axis: getValueToPass(),
      incoTerm: incoterm,
      dateType: dateType,
      activeTab: activeTab,
      reasonCode: reasonCode,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        PL3: PL3,
        Division: Division,
        CL6,
        Products: Products,
        SoldToName: Customers,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    };
    GraphService.getExcelData(params, instance)
      .then((data) => {
        if (data?.data) {
          exportToExcel(data?.data, "OnTimeDeliveryGuardian");
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setTopOrBottomValue("Top");
    setCountValue("5");
    // console.log("newValue: ", newValue, radioButtonSelected)
    if (
      (newValue === 0 || newValue === 3) &&
      radioButtonSelected === "Reason Codes"
    ) {
      // setSelectedRadioValue("Customer Group");
      setIOFPBRadioButton("Customer Group");
    }
  };

  const handleRadioChange = (selectedFilter) => {
    //setSelectedRadioValue(selectedFilter);
    setIOFPBRadioButton(selectedFilter);
  };

  const handleExportExcel = () => {
    getDataForExport();
  };

  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };
  const handleReasonCodeChange = (event) => {
    setReasonCode(event.target.value);
  };

  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };

  const renderChart = () => {
    if (activeTab === "Reason Codes") {
      return <ReasonCodeChart graphData={graphData} activeTab={activeTab} />;
    } else if (activeTab === "Expected On-time") {
      return <ExpetedTimeChart graphData={graphData} activeTab={activeTab} />;
    } else {
      return (
        <SingleBarChartForRDD graphData={graphData} activeTab={activeTab} />
      );
    }
  };
  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "22px 8px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    rowGap: "13px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <Select
                        value={topOrBottomValue}
                        onChange={handleTopBottomChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        <MenuItem value="Top">Top</MenuItem>
                        <MenuItem value={"Bottom"}>Bottom</MenuItem>
                      </Select>
                      <Select
                        value={countValue}
                        onChange={handleCountChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        {activeTab === "Reason Codes"
                          ? countListReasonCode.map((item, _index) => (
                              <MenuItem key={item} value={item}>
                                {item}
                              </MenuItem>
                            ))
                          : countList.map((item, _index) => (
                              <MenuItem key={item} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                      </Select>
                    </div>
                    <div style={{ alignSelf: "flex-end" }}>
                      <Button
                        variant="contained"
                        startIcon={<FileDownloadIcon fontSize="18px" />}
                        sx={{
                          fontFamily: "Poppins, sans-serif", // Make sure Poppins is specified here
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#59595A",
                          background: "#ffffff",
                          height: "30px",
                          marginRight: "5px",
                          marginLeft: "10px",
                          textTransform: "none",
                          boxShadow: "none",
                          border: "1px solid #D3D3D3",
                          "&:hover": {
                            background: "#ffffff", // Prevent background color change on hover
                            boxShadow: "none", // Prevent shadow changes on hover
                          },
                        }}
                        onClick={handleExportExcel}
                      >
                        Export
                      </Button>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    {radioOptions().map((option) => (
                      <React.Fragment key={option}>
                        <Radio
                          value={option}
                          checked={radioButtonSelected === option}
                          onChange={() => handleRadioChange(option)}
                          size="small"
                          inputProps={{ "aria-label": option }}
                          sx={{
                            color: "#359DD0 !important",
                            "&.Mui-checked": {
                              color: "#359DD0 !important",
                            },
                          }}
                        />
                        <span
                          className={classes.filter}
                          style={{
                            color:
                              radioButtonSelected ===
                              (Module === "SNO" ? "Overall" : "Network")
                                ? "#359DD0"
                                : "#359DD0",
                          }}
                        >
                          {option}
                        </span>
                      </React.Fragment>
                    ))}
                    <Tooltip title={getTooltipTitle(activeTab)} placement="top">
                      <InfoOutlinedIcon
                        fontSize="small"
                        style={{
                          color: "blue",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <div style={{display: "flex", alignItems: "center"}}>
                                        <div>
                                            <InputLabel  
                                            id="date-label"
                                            >
                                                IncoTerm
                                            </InputLabel>
                                        </div>
                                        <ListItem>
                                            <Select
                                            value={incoTerm}
                                            onChange={handleIncoTerm}
                                            className={classes.selectList}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            sx={classes.select}
                                            >
                                                <MenuItem value={"All"}>
                                                    All
                                                </MenuItem>
                                                <MenuItem value={"DDP"}>
                                                    DDP
                                                </MenuItem>
                                                <MenuItem value={"EXW"}>
                                                    EXW
                                                </MenuItem>
                                            </Select>
                                        </ListItem>
                                    </div> */}
                    {/* <div style={{display:"flex",justifyContent:"space-between"}}> */}
                    {activeTab === "Reason Codes" && (
                      <div>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#aaaaaaff",
                            mb: "4px",
                            marginLeft: "18px",
                          }}
                        >
                          Type
                        </Typography>
                        <ListItem>
                          <Select
                            value={reasonCode}
                            onChange={handleReasonCodeChange}
                            className={classes.selectList}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            sx={classes.select}
                          >
                            {" "}
                            <MenuItem value={"All"}>All</MenuItem>
                            <MenuItem value={"1M"}>1M</MenuItem>
                            <MenuItem value={"2S"}>2S</MenuItem>
                            <MenuItem value={"AM"}>AM</MenuItem>
                            <MenuItem value={"CB"}>CB</MenuItem>
                            <MenuItem value={"CF"}>CF</MenuItem>
                            <MenuItem value={"KE"}>KE</MenuItem>
                            <MenuItem value={"L2"}>L2</MenuItem>
                            <MenuItem value={"LS"}>LS</MenuItem>
                            <MenuItem value={"LT"}>LT</MenuItem>
                            <MenuItem value={"NT"}>NT</MenuItem>
                            <MenuItem value={"UK"}>UK</MenuItem>
                          </Select>
                        </ListItem>
                      </div>
                    )}

                    {/* </div> */}
                  </div>
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphViewIOFPB.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  Customers: state.filter.Customers,
  PL3: state.filter.PL3,
  CL6: state.filter.CL6,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
  setIOFPBRadioButton: (newValue) =>
    dispatch({ type: "SET_IOFPB_RADIO_BUTTON", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphViewIOFPB);
